import { Component, Input, OnInit } from '@angular/core';
import { NgIf } from '@angular/common';
import { UiCorePipesModule } from '@softline/ui-core';

@Component({
  selector: 'soft-dynamic-entity-value',
  templateUrl: './entity.component.html',
  styleUrls: ['./entity.component.scss'],
  imports: [NgIf, UiCorePipesModule],
})
export class EntityComponent implements OnInit {
  @Input() value?: any;
  @Input() format = '';

  constructor() {}

  ngOnInit(): void {}
}
